import checkout from "./form2";

const {
  formField2: {
    countryName,
    carrierName,
    year,
    supplementaryForThe,
    firstTime,
    vehicleName,
    taxPayerInstead,
    taxPayerInsteadId
  },
} = checkout;

const initialValues2 = {
  [countryName.name]: "",
  [carrierName.name]: "",
  [year.name]: "",
  [supplementaryForThe.name]: "",
  [firstTime.name]: false,
  [vehicleName.name]: "",
  [taxPayerInstead.name]: "",
  [taxPayerInsteadId.name]: "",
};

export default initialValues2;
